import { TransportTypology } from './enums/transport-typology.enum';
import { HandlingTypeEnum } from './enums/handling-type.enum';

export class HandlingTypeViewModel {
  public hazardousMaterial?: boolean;
  public controlledTemperature?: boolean;
  public transportTypology?: TransportTypology;
  public handlingTypes: HandlingTypeEnum[] = [];

  constructor(data: any = {}) {
    Object.assign(this, data);
    //TODO: A supprimer lors de la suppression du HandlingTypeEnum.PERSONALIZED (Doit arriver dans le lot 2)
    this.handlingTypes = (data.handlingTypes || []).filter((handlingType: HandlingTypeEnum) => handlingType !== HandlingTypeEnum.PERSONALIZED && handlingType !== HandlingTypeEnum.INDIVISIBLE);
  }
}
